import React from 'react';

function WorkshopCard({ workshop, onOpen, index = 0, isVisible = false }) {
  const { title, instructor, image, short } = workshop;

  return (
    <button
      type="button"
      onClick={() => onOpen(workshop)}
      style={{ transitionDelay: `${(index % 3) * 100}ms` }}
      className={`group text-left bg-white rounded-2xl shadow-sm hover:shadow-md overflow-hidden focus:outline-none focus:ring-2 focus:ring-blue-700 h-full flex flex-col transition-all duration-500 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'
      }`}
      aria-label={`Otwórz szczegóły warsztatu: ${title}`}
    >
      <div className="aspect-[3/4] w-full overflow-hidden bg-gray-100">
        <img
          src={image}
          alt={`Instruktor: ${instructor} – ${title}`}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>

      <div className="p-4 text-blue-900 flex-1 flex flex-col">
        <h3 className="text-lg font-bold leading-snug">{title}</h3>
        <p className="text-sm text-blue-900/70 mt-1">{instructor}</p>

        {short ? (
          <p className="text-sm text-blue-900 mt-3 leading-relaxed">{short}</p>
        ) : null}
      </div>
    </button>
  );
}

export default WorkshopCard;
